import { Component, Host, h, Method, Prop, State } from '@stencil/core';
import axios from '../../../utils/get-axios';

const ACC = (window as any).ACC;
@Component({
  tag: 'lilu-select',
  styleUrl: 'lilu-select.scss',
  shadow: true,
})
export class LiluSelect {
  @Prop() options: string;
  @Prop() size = 'size-sm';
  @Prop() productId: string;
  @Prop() variantSwitch: boolean;
  @Prop() ajaxUrl?: string;
  @Prop() hybrisMaterialsJson: false;

  @State() jsonOptions: any[] = [];

  CSRFToken: string = ACC?.config.CSRFToken;

  componentWillLoad() {
    if (this.options !== undefined) {
      this.jsonOptions = JSON.parse(this.options);
    }

    if (this.hybrisMaterialsJson) {
      this.jsonOptions = this.mapVariantMaterials(this.jsonOptions);
    }
  }

  mapVariantMaterials(variantMaterials) {
    return variantMaterials.map(material => ({
      productUrl: material.url,
      productNumber: material.code,
      selected: material.selected,
      text: `${material.material} ${material.measure}`,
    }));
  }

  @Method()
  async switchVariant(event) {
    const productId = event.target.value;
    axios
      .post(
        `${this.ajaxUrl}/${productId}`,
        {},
        {
          headers: {
            CSRFToken: ACC.config.CSRFToken,
          },
        },
      )
      .then(response => {
        const currentTile = document.querySelector(`lilu-product-tile[data-product-id="${this.productId}"]`);
        const newTile = this.htmlToElement(response.data);
        currentTile.parentNode.replaceChild(newTile, currentTile);
      });
  }

  /**
   * Generate a virtual DOM element from a HTML String an returns HTML Node
   * @param html string
   * @returns HTML Node
   */
  htmlToElement(html) {
    const template = document.createElement('template');
    template.innerHTML = html.trim();
    return template.content.firstChild;
  }

  redirectToProduct(event) {
    window.location.href = event.target.value;
  }

  render() {
    const selectOptions = this.jsonOptions.map(option => (
      <option value={this.variantSwitch ? option.productNumber : option.productUrl} selected={option.selected} data-productid={option.productNumber}>
        {option.text}
      </option>
    ));

    const handleChange = this.variantSwitch ? event => this.switchVariant(event) : event => this.redirectToProduct(event);

    return (
      <Host>
        <div class={`form select ${this.size}`}>
          <select class="form select" onChange={handleChange}>
            {selectOptions}
          </select>
          <div class="select__arrow">
            <lilu-icon color="nero" type="icon-chevron-down"></lilu-icon>
          </div>
        </div>
      </Host>
    );
  }
}
